import { gql, useLazyQuery } from '@apollo/client'
import { SearchGraphql, ResultsList, Metadata } from '../../../../../core/models'
import { useEffect, useState } from 'react'
import { IssuedTickets } from '../models'

const ISSUED_TICKETS_QUERY = gql`
  query IssuedTickets(
    $date: DateTime!,
    $partialTicketNumber: String!,
    $agencyId: String!,
    $workstationId: String!,
    $product: ProductEnum!,
    $amount: Decimal!,
    $username: String!,
    $userFullName: String!
  ) {
    issuedTickets(
      date: $date,
      partialTicketNumber: $partialTicketNumber,
      agencyId: $agencyId,
      workstationId: $workstationId,
      product: $product,
      amount: $amount,
      username: $username,
      userFullName: $userFullName
    ) {
      status
      date
      providerTicketNumbers
      totalAmount
      number
      surcharge
      finalTransaction {
        date
        agency {
          name
        }
        workstation {
          name
        }
      }
      workstation {
        name
        agency {
          name
          products {
            code
          }
        }
        enterprise {
          name
        }
      }
      horseRacesWagerCollections {
        event {
          league {
            name
            product
            sport
          }
          eventDate
          eventTime
          eventId
          eventName
          eventStatus
          provider
        }
        wagerPayoff {
          ticketId
          claimed
          paid
          payoff {
            net
          }
        }
        postTime
        race
        displayValue
        wagers {
          date
          poolId
          modifier
          race
          combine
          poolRaces
          pick
          quick
          legs {
            raceId
            runners {
              runnerId
              entries {
                id
                entryId
                name
                scratch
                jockey
                weight
                trainer
                owner
                position
                medication
                entryChanges {
                  name
                  jockey
                  weight
                  trainer
                  owner
                  position
                  other
                }
              }
              odds
              scratch
            }
          }
          bet
          total
          commission
          surcharge
          displayValue
          wagerCombinations
          segments
        }
        providerTicketId
      }
    }
  }
`

export const useIssuedTicketBySequence = () => {
  const [getResults, { loading, error, data }] = useLazyQuery(ISSUED_TICKETS_QUERY, {
    fetchPolicy: 'network-only',
  })

  const [results, setResults] = useState<ResultsList<IssuedTickets, Metadata>>({
    results: [],
    metadata: {},
  })

  useEffect(() => {
    if (data?.issuedTickets) {
      // Convert the single ticket result to an array for consistency with previous implementation
      const ticketsArray = Array.isArray(data.issuedTickets) ? data.issuedTickets : [data.issuedTickets];
      
      setResults({
        results: ticketsArray.filter(ticket => ticket !== null),
        metadata: {
          Count: ticketsArray.length,
        },
      })
    }
  }, [data, loading])

  const getIssuedTickets = (params: {
    date: string,
    partialTicketNumber: string,
    agencyId: string,
    workstationId: string,
    product: string,
    amount: number,
    username: string,
    userFullName: string
  }) => {
    getResults({
      variables: {
        date: params.date,
        partialTicketNumber: params.partialTicketNumber,
        agencyId: params.agencyId,
        workstationId: params.workstationId,
        product: params.product,
        amount: params.amount,
        username: params.username,
        userFullName: params.userFullName
      },
    })
  }
  
  return { loading, error, count: results.metadata.Count, issuedTickets: data?.issuedTickets ? results.results : [], getIssuedTickets }
}
